import { toastr } from 'react-redux-toastr';
import config, {AUTH_INVALID_MESSAGE, AUTH_INVALID_TOKEN, SERVICE_LOGICAL_ACCESS_DENIED} from "../../config/config";
import {dropToken} from "../../components/UserLogin/actions";

export const REQUEST_COMPANIES = 'REQUEST_COMPANIES';
export const RECEIVE_COMPANIES = 'RECEIVE_COMPANIES';
export const REQUEST_SEGMENTS = 'REQUEST_SEGMENTS';
export const RECEIVE_SEGMENTS = 'RECEIVE_SEGMENTS';

export const SET_COUNTRY_FILTER = 'SET_COUNTRY_FILTER';
export const SET_SEGMENT_FILTER = 'SET_SEGMENT_FILTER';
export const CLEAR_COUNTRY_FILTER = 'CLEAR_COUNTRY_FILTER';
export const CLEAR_SEGMENT_FILTER = 'CLEAR_SEGMENT_FILTER';

export const SET_SEARCH = 'SET_SEARCH';
export const CLEAR_SEARCH = 'CLEAR_SEARCH';

export const requestCompanies = () => ({
    type: REQUEST_COMPANIES,
});

export const receiveCompanies = (companies, page = 1) => ({
    type: RECEIVE_COMPANIES,
    companies,
    page,
});

export const setCountryFilter = (country) => ({
    type: SET_COUNTRY_FILTER,
    country,
});

export const setSegmentFilter = (segment) => ({
    type: SET_SEGMENT_FILTER,
    segment,
});

export const clearCountryFilter = () => ({
    type: CLEAR_COUNTRY_FILTER,
});

export const clearSegmentFilter = () => ({
    type: CLEAR_SEGMENT_FILTER,
});

export const requestSegments = () => ({
    type: REQUEST_SEGMENTS,
});

export const receiveSegments = (segments) => ({
    type: RECEIVE_SEGMENTS,
    segments
});

export const setCompSearch = (search) => ({
    type: SET_SEARCH,
    search,
});

export const clearCompSearch = () => ({
    type: CLEAR_SEARCH,
});

export const COMPANIES_PAGE_COUNT = 20;

const process_api_error = (json, dispatch) => {
    dispatch(receiveCompanies([]));
    if (json.code === AUTH_INVALID_TOKEN) {
        dispatch(dropToken());
        toastr.error(AUTH_INVALID_MESSAGE);
    } else
    if (json.code === SERVICE_LOGICAL_ACCESS_DENIED)
        toastr.error(json.message);
    else
        toastr.error('Ошибка сервера: ' + String(json.code) + '. ' + json.message);
};

export const fetchCompanies = (params = {}) => (dispatch) => {

    dispatch(requestCompanies( params.page ?? 1 ));

    let url = config.API_COMPANIES_URL;
    if (params)
        url += '?'
            + Object.keys(params)
                .map((k) => k + '=' + encodeURIComponent(params[k]))
                .join('&');

    return fetch(url)
        .then((response) => response.json())
        .then((json) => {
            // console.log('fetch companies result', json, url);
            if (json.code === 200) {
                dispatch(receiveCompanies(json.data, params.page ?? 1));
                // console.log('fetch companies', json.data, params.page ?? 1, url);
            } else {
                process_api_error(json, dispatch);
            }
        })
        .catch((error) => {
            toastr.error('Ошибка запроса', String(error));
            dispatch(receiveCompanies([]));
        });
};

export const fetchSegments = (params = {}) => (dispatch) => {

    dispatch(requestSegments( params.page ?? 1 ));

    let url = config.API_SEGMENTS_URL;
    if (params)
        url += '?'
            + Object.keys(params)
                .map((k) => k + '=' + encodeURIComponent(params[k]))
                .join('&');

    return fetch(url)
        .then((response) => response.json())
        .then((json) => {
            if (json.code === 200) {
                dispatch(receiveSegments(json.data, params.page ?? 1));
            } else {
                dispatch(receiveSegments([]));
                process_api_error(json, dispatch);
            }
        })
        .catch((error) => {
            toastr.error('Ошибка запроса', String(error));
            dispatch(receiveSegments([]));
        });
};
